import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Container, Row, Col, FormGroup, Label, InputGroup, Input, Button, Form } from "reactstrap";
import Joi from "joi-browser";
import { toastBigError } from "components/utils/toasts";
import { getBebida, saveBebida, uploadFoto } from "services/bebidaService";
import Switch from "react-bootstrap-switch";
import FileUploadContainer from "components/fileUploader/fileUploader";

import { getConfig } from "config/config";

const BebidasForm = ({ props, onLoading, onDoneLoading }) => {
  const history = useHistory();
  const location = useLocation();

  const [data, setData] = useState({
    _id: "",
    descripcion: "",
    foto: "",
    disponible: false,
  });
  const [errors, setErrors] = useState([]);
  const [action, setAction] = useState(location.state?.action ? location.state.action : "");
  const validateForm = true;

  const config = getConfig();

  const filesUrl = config.filesUrl + "/bebidas/";

  const schema = {
    _id: Joi.string().allow(""),
    descripcion: Joi.string()
      .label("Descripción")
      .required()
      .error((errors) => {
        return errors.map((error) => {
          switch (error.type) {
            case "any.empty":
              return { message: "Debe ingresar una descripción" };
            default:
              return { message: "Debe ingresar una descripción" };
          }
        });
      }),
    foto: Joi.string().allow(""),
    disponible: Joi.boolean(),
  };

  const fetchData = async (id) => {
    const record = await getBebida(id);
    mapToViewModel(record);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    const id = props.match.params.id;
    if (!id.includes("nuev")) {
      fetchData(id);
    } else {
      setAction("A");
    }
  }, []);

  const mapToViewModel = (bebida) => {
    setData({
      _id: bebida._id,
      descripcion: bebida.descripcion,
      //   foto: bebida.foto,
      disponible: bebida.disponible,
    });
  };

  const handleChange = (event) => {
    const input = event.currentTarget;
    const inputMode = event.target.inputMode;
    const cacheErrors = { ...errors };
    const cacheData = { ...data };
    if (validateForm) {
      const errorMessage = validateProperty(input, inputMode);
      if (errorMessage) {
        cacheErrors[input.name] = errorMessage;
      } else delete cacheErrors[input.name];
    } else delete cacheErrors[input.name];
    cacheData[input.name] = input.value;
    if (input.type === "checkbox") cacheData[input.name] = input.checked;
    setData(cacheData);
    setErrors(cacheErrors);
  };

  const handleChangeSwitch = (sw) => {
    const cacheData = { ...data };
    if (sw === "disponible") cacheData["disponible"] = !cacheData["disponible"];
    setData(cacheData);
  };

  const validateRules = () => {
    return null;
  };

  const validate = () => {
    let errors = {};
    const options = { abortEarly: false };
    if (validateForm) {
      //   var { data } = this.state;
      Object.keys(data).map(function (key, index) {
        if (
          (key.toLowerCase().includes("dni") || key.toLowerCase().includes("documento")) &&
          !key.toLowerCase().includes("tipo")
        ) {
          const valor = data[key];
          const stripped = valor.replaceAll(".", "");
          if (stripped.length === 8) {
            const nuevoValor =
              stripped.substring(0, 2) + "." + stripped.substring(2, 5) + "." + stripped.substring(5, 8);
            data[key] = nuevoValor;
          }
          if (stripped.length === 7) {
            const nuevoValor =
              stripped.substring(0, 1) + "." + stripped.substring(1, 4) + "." + stripped.substring(4, 7);
            data[key] = nuevoValor;
          }
        }
        if (typeof data[key] === "object" && data[key] && data[key].value && typeof data[key].value === "string") {
          data[key] = data[key].value;
        }
      });
      let { error } = Joi.validate(data, schema, options);
      if (!error) {
        error = validateRules();
        if (!error) {
          Object.keys(data).map(function (key, index) {
            if (typeof data[key] === "object" && data[key] && data[key].value) data[key] = data[key].value;
          });
          return null;
        }
        error.map((error) => {
          toastBigError(error.message, 2500);
          return (errors[error.path] = error.message);
        });
        return errors;
      } else {
        error.details.map((validationError) => {
          return (errors[validationError.path[0]] = validationError.message);
        });
        return errors;
      }
    } else return null;
  };

  const validateProperty = (input, inputMode) => {
    let { name, value } = input;
    if (inputMode === "numeric") {
      const index = value.indexOf(" ");
      value = parseFloat(value.substr(value.indexOf(" ") + 1));
    }
    const object = { [name]: value };
    const checkSchema = { [name]: schema[name] };
    const { error } = Joi.validate(object, checkSchema);
    return error ? error.details[0].message : null;
  };

  const prepareData = () => {};

  const handleSubmit = async (event) => {
    prepareData();
    if (event) event.preventDefault();
    const checkErrors = validate();
    if (checkErrors) {
      setErrors(checkErrors);
      return;
    }
    doSubmit();
  };

  const doSubmit = async () => {
    const datos = { ...data };
    const newId = await saveBebida(data);
    history.push({ pathname: "/bebidas" });
    // if (data._id) history.push({ pathname: "/bebidas" });
    // else {
    //   datos._id = newId;
    //   setData(datos);
    // }
  };

  const goBack = () => {
    history.goBack();
  };

  const uploadImage = async (uploadData) => {
    const datos = { ...data };
    const filename = await uploadFoto(datos._id, uploadData, datos.foto);
    if (filename) {
      datos.foto = filename;
      setData(datos);
    }
  };

  return (
    <>
      <Container className="wrapper">
        <form onSubmit={handleSubmit}>
          <h3 className="mt-4 mb-2">Bebidas</h3>
          <Row className="mt-4 mb-2 align-items-center">
            <Col sm="12">
              <InputGroup className={(errors["descripcion"] ? "has-danger" : "") + " align-items-center"}>
                <h6>
                  <Label className="mb-0" style={{ marginRight: "20px" }}>
                    Descripción
                  </Label>
                </h6>
                <Input
                  autoFocus
                  disabled={action === "C"}
                  className={errors["descripcion"] ? "text-control-danger" : ""}
                  type="text"
                  name="descripcion"
                  value={data.descripcion}
                  onChange={(event) => handleChange(event)}
                />
                {errors["descripcion"] ? <div className="form-control-feedback">{errors["descripcion"]}</div> : ""}
              </InputGroup>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col sm="12">
              <InputGroup className="align-items-center">
                <h6>
                  <Label className="mb-0 mr-2">Disponible</Label>
                </h6>
                <Switch
                  onColor="success"
                  offColor="default"
                  onText=""
                  offText=""
                  name="disponible"
                  value={data.disponible}
                  onChange={() => handleChangeSwitch("disponible")}
                />
              </InputGroup>
            </Col>
          </Row>
          <Row className="justify-content-center mt-3">
            {action !== "C" ? (
              <Button outline className="btn-round mr-1" color="success" type="button" onClick={handleSubmit}>
                {/* {data._id ? "Guardar" : "Continuar"} */}
                Guardar
              </Button>
            ) : (
              ""
            )}
            {data._id && (
              <Button outline className="btn-round mr-1" color="danger" type="button" onClick={goBack}>
                {action === "C" ? "Vovler" : "Cancelar"}
              </Button>
            )}
          </Row>
        </form>
      </Container>
    </>
  );
};

export default BebidasForm;
